import React from 'react';
import { Container } from 'react-bootstrap';

const Resume = () => {
  return (
    <Container id="Resume">
      <div>
        <h2 className="header-clr">Resume</h2>
        <div className="divider"></div>
        <br />
        <p>
          A summary of my professional software engineering background, hands-on production experience, and academic foundation in Computer Science.
        </p>
        <br />
        <div className="resume-main">
          {/* Left Column: Summary & Education */}
          <div className="resume-left">
            <h4 className="header-clr"><b>&ensp;Summary</b></h4>
            <div className="list-wrapper">
              <div className="red-line"></div>
              <div className="list-item-wrapper">
                <div className="list-bullet"></div>
                <div className="list-item">
                  <div className="list-title">
                    <h5><b>BABU BALAJI V</b></h5>
                  </div>
                  <div className="list-text">
                    <p>
                      Full-Stack Developer with 2 years of hands-on experience designing and scaling high-performance web applications across MERN and Java Spring Boot ecosystems. Proven expertise in microservices, RESTful API engineering, Redis caching, and responsive frontend optimization.
                    </p>
                    <ul>
                      <li>Bengaluru, India</li>
                      <li>+91 8778418841</li>
                      <li>babu.balajijr@gmail.com</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <br />

            <h4 className="header-clr"><b>&ensp;Education</b></h4>
            <div className="list-wrapper">
              <div className="red-line"></div>
              <div className="list-item-wrapper">
                <div className="list-bullet"></div>
                <div className="list-item">
                  <div className="list-title">
                    <h5><b>SASTRA DEEMED UNIVERSITY ( B.TECH - CSE )</b></h5>
                    <div className="year-span">&emsp;2020 – 2024</div>
                  </div>
                  <div className="list-text">
                    <p>Thanjavur, Tamil Nadu | <b>CGPA: 7.5 / 10</b></p>
                    <p>Focused on Data Structures, Algorithms, DBMS, Operating Systems, Computer Networks, and Full-Stack Web Development.</p>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>

          {/* Right Column: Experience */}
          <div className="resume-right">
            <h4 className="header-clr"><b>&ensp;Professional Experience</b></h4>
            <div className="list-wrapper">
              <div className="red-line"></div>
              
              {/* TCS Experience */}
              <div className="list-item-wrapper">
                <div className="list-bullet"></div>
                <div className="list-item">
                  <div className="list-title">
                    <h5><b>Tata Consultancy Services ( SYSTEM ENGINEER )</b></h5>
                    <div className="year-span">&emsp;Nov 2024 – Present</div>
                  </div>
                  <div className="list-text">
                    <p>Bengaluru, India</p>
                    <ul>
                      <li>Architected and optimized full-stack modules using Java Spring Boot and React.js, reducing server response times by 25% across enterprise services.</li>
                      <li>Implemented stateless, role-based JWT authentication and encrypted RESTful API pipelines to ensure zero security vulnerabilities across client portals.</li>
                      <li>Re-engineered UI workflows using React.js and Bootstrap, improving cross-browser compatibility and decreasing initial page load latency by 30%.</li>
                      <li>Collaborated in cross-functional Agile sprints to deliver production-ready features within strict enterprise release cycles and SLAs.</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* IndieSpirit Experience */}
              <div className="list-item-wrapper">
                <div className="list-bullet"></div>
                <div className="list-item">
                  <div className="list-title">
                    <h5><b>IndieSpirit Technologies ( FULL-STACK DEVELOPER INTERN )</b></h5>
                    <div className="year-span">&emsp;Dec 2023 – Jun 2024</div>
                  </div>
                  <div className="list-text">
                    <p>Chennai, India</p>
                    <ul>
                      <li>Developed full-stack SaaS features using the MERN stack (MongoDB, Express.js, React.js, Node.js), ensuring resilient data contracts and asynchronous state handling.</li>
                      <li>Optimized frontend bundle sizes and component lifecycles, boosting overall dashboard responsiveness by 20% based on user analytics.</li>
                      <li>Designed Mongoose schema aggregations and compound database indexes, optimizing read query performance for high-volume transactions.</li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <br />
      </div>
    </Container>
  );
};

export default Resume;